import { ComponentsProps } from "@material-ui/core/styles/props";

const props: ComponentsProps = {
  MuiCardHeader: {
    titleTypographyProps: { variant: "h6" },
  },
};

export default props;
